import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import statusCodes from '../statusCodes';

var UsernameAlreadyExists = /*#__PURE__*/function (_Error) {
  _inherits(UsernameAlreadyExists, _Error);

  var _super = _createSuper(UsernameAlreadyExists);

  function UsernameAlreadyExists() {
    var _this;

    _classCallCheck(this, UsernameAlreadyExists);

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(params));
    _this.name = 'UsernameAlreadyExists';
    _this.message = 'Username already exists.';
    _this.status = statusCodes['Conflict'];
    return _this;
  }

  return UsernameAlreadyExists;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsernameMissing = /*#__PURE__*/function (_Error2) {
  _inherits(UsernameMissing, _Error2);

  var _super2 = _createSuper(UsernameMissing);

  function UsernameMissing() {
    var _this2;

    _classCallCheck(this, UsernameMissing);

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(params));
    _this2.name = 'UsernameMissing';
    _this2.message = 'Username missing.';
    _this2.status = statusCodes['Bad Request'];
    return _this2;
  }

  return UsernameMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsernameCannotBeBlank = /*#__PURE__*/function (_Error3) {
  _inherits(UsernameCannotBeBlank, _Error3);

  var _super3 = _createSuper(UsernameCannotBeBlank);

  function UsernameCannotBeBlank() {
    var _this3;

    _classCallCheck(this, UsernameCannotBeBlank);

    for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      params[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(params));
    _this3.name = 'UsernameCannotBeBlank';
    _this3.message = 'Username cannot be blank.';
    _this3.status = statusCodes['Bad Request'];
    return _this3;
  }

  return UsernameCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsernameTooLong = /*#__PURE__*/function (_Error4) {
  _inherits(UsernameTooLong, _Error4);

  var _super4 = _createSuper(UsernameTooLong);

  function UsernameTooLong(maxLen) {
    var _this4;

    _classCallCheck(this, UsernameTooLong);

    for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      params[_key4 - 1] = arguments[_key4];
    }

    _this4 = _super4.call.apply(_super4, [this, maxLen].concat(params));
    _this4.name = 'UsernameTooLong';
    _this4.message = "Username too long. Must be a max of ".concat(maxLen, " characters.");
    _this4.status = statusCodes['Bad Request'];
    return _this4;
  }

  return UsernameTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsernameMustBeString = /*#__PURE__*/function (_Error5) {
  _inherits(UsernameMustBeString, _Error5);

  var _super5 = _createSuper(UsernameMustBeString);

  function UsernameMustBeString() {
    var _this5;

    _classCallCheck(this, UsernameMustBeString);

    for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      params[_key5] = arguments[_key5];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(params));
    _this5.name = 'UsernameMustBeString';
    _this5.message = 'Username must be a string.';
    _this5.status = statusCodes['Bad Request'];
    return _this5;
  }

  return UsernameMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordMissing = /*#__PURE__*/function (_Error6) {
  _inherits(PasswordMissing, _Error6);

  var _super6 = _createSuper(PasswordMissing);

  function PasswordMissing() {
    var _this6;

    _classCallCheck(this, PasswordMissing);

    for (var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      params[_key6] = arguments[_key6];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(params));
    _this6.name = 'PasswordMissing';
    _this6.message = 'Password missing.';
    _this6.status = statusCodes['Bad Request'];
    return _this6;
  }

  return PasswordMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordCannotBeBlank = /*#__PURE__*/function (_Error7) {
  _inherits(PasswordCannotBeBlank, _Error7);

  var _super7 = _createSuper(PasswordCannotBeBlank);

  function PasswordCannotBeBlank() {
    var _this7;

    _classCallCheck(this, PasswordCannotBeBlank);

    for (var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      params[_key7] = arguments[_key7];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(params));
    _this7.name = 'PasswordCannotBeBlank';
    _this7.message = 'Password cannot be blank.';
    _this7.status = statusCodes['Bad Request'];
    return _this7;
  }

  return PasswordCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordTooShort = /*#__PURE__*/function (_Error8) {
  _inherits(PasswordTooShort, _Error8);

  var _super8 = _createSuper(PasswordTooShort);

  function PasswordTooShort(minLen) {
    var _this8;

    _classCallCheck(this, PasswordTooShort);

    for (var _len8 = arguments.length, params = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
      params[_key8 - 1] = arguments[_key8];
    }

    _this8 = _super8.call.apply(_super8, [this, minLen].concat(params));
    _this8.name = 'PasswordTooShort';
    _this8.message = "Password too short. Must be a minimum of ".concat(minLen, " characters.");
    _this8.status = statusCodes['Bad Request'];
    return _this8;
  }

  return PasswordTooShort;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordTooLong = /*#__PURE__*/function (_Error9) {
  _inherits(PasswordTooLong, _Error9);

  var _super9 = _createSuper(PasswordTooLong);

  function PasswordTooLong(maxLen) {
    var _this9;

    _classCallCheck(this, PasswordTooLong);

    for (var _len9 = arguments.length, params = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
      params[_key9 - 1] = arguments[_key9];
    }

    _this9 = _super9.call.apply(_super9, [this, maxLen].concat(params));
    _this9.name = 'PasswordTooLong';
    _this9.message = "Password too long. Must be a max of ".concat(maxLen, " characters.");
    _this9.status = statusCodes['Bad Request'];
    return _this9;
  }

  return PasswordTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordMustBeString = /*#__PURE__*/function (_Error10) {
  _inherits(PasswordMustBeString, _Error10);

  var _super10 = _createSuper(PasswordMustBeString);

  function PasswordMustBeString() {
    var _this10;

    _classCallCheck(this, PasswordMustBeString);

    for (var _len10 = arguments.length, params = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      params[_key10] = arguments[_key10];
    }

    _this10 = _super10.call.apply(_super10, [this].concat(params));
    _this10.name = 'PasswordMustBeString';
    _this10.message = 'Password must be a string.';
    _this10.status = statusCodes['Bad Request'];
    return _this10;
  }

  return PasswordMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PasswordAttemptLimitExceeded = /*#__PURE__*/function (_Error11) {
  _inherits(PasswordAttemptLimitExceeded, _Error11);

  var _super11 = _createSuper(PasswordAttemptLimitExceeded);

  function PasswordAttemptLimitExceeded(delay) {
    var _this11;

    _classCallCheck(this, PasswordAttemptLimitExceeded);

    for (var _len11 = arguments.length, params = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
      params[_key11 - 1] = arguments[_key11];
    }

    _this11 = _super11.call.apply(_super11, [this, delay].concat(params));
    _this11.name = 'PasswordAttemptLimitExceeded';
    _this11.message = "Password attempt limit exceeded. Must wait ".concat(delay, " to attempt to use password again.");
    _this11.status = statusCodes['Unauthorized'];
    return _this11;
  }

  return PasswordAttemptLimitExceeded;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UsernameOrPasswordMismatch = /*#__PURE__*/function (_Error12) {
  _inherits(UsernameOrPasswordMismatch, _Error12);

  var _super12 = _createSuper(UsernameOrPasswordMismatch);

  function UsernameOrPasswordMismatch() {
    var _this12;

    _classCallCheck(this, UsernameOrPasswordMismatch);

    for (var _len12 = arguments.length, params = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      params[_key12] = arguments[_key12];
    }

    _this12 = _super12.call.apply(_super12, [this].concat(params));
    _this12.name = 'UsernameOrPasswordMismatch';
    _this12.message = 'Username or password mismatch.';
    _this12.status = statusCodes['Unauthorized'];
    return _this12;
  }

  return UsernameOrPasswordMismatch;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SessionLengthMustBeNumber = /*#__PURE__*/function (_Error13) {
  _inherits(SessionLengthMustBeNumber, _Error13);

  var _super13 = _createSuper(SessionLengthMustBeNumber);

  function SessionLengthMustBeNumber() {
    var _this13;

    _classCallCheck(this, SessionLengthMustBeNumber);

    for (var _len13 = arguments.length, params = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      params[_key13] = arguments[_key13];
    }

    _this13 = _super13.call.apply(_super13, [this].concat(params));
    _this13.name = 'SessionLengthMustBeNumber';
    _this13.message = 'Session length must be a number.';
    _this13.status = statusCodes['Bad Request'];
    return _this13;
  }

  return SessionLengthMustBeNumber;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SessionLengthTooShort = /*#__PURE__*/function (_Error14) {
  _inherits(SessionLengthTooShort, _Error14);

  var _super14 = _createSuper(SessionLengthTooShort);

  function SessionLengthTooShort(minLen) {
    var _this14;

    _classCallCheck(this, SessionLengthTooShort);

    for (var _len14 = arguments.length, params = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
      params[_key14 - 1] = arguments[_key14];
    }

    _this14 = _super14.call.apply(_super14, [this, minLen].concat(params));
    _this14.name = 'SessionLengthTooShort';
    _this14.message = "Session length cannot be shorter than ".concat(minLen, ".");
    _this14.status = statusCodes['Bad Request'];
    return _this14;
  }

  return SessionLengthTooShort;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var SessionLengthTooLong = /*#__PURE__*/function (_Error15) {
  _inherits(SessionLengthTooLong, _Error15);

  var _super15 = _createSuper(SessionLengthTooLong);

  function SessionLengthTooLong(maxLen) {
    var _this15;

    _classCallCheck(this, SessionLengthTooLong);

    for (var _len15 = arguments.length, params = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
      params[_key15 - 1] = arguments[_key15];
    }

    _this15 = _super15.call.apply(_super15, [this, maxLen].concat(params));
    _this15.name = 'SessionLengthTooLong';
    _this15.message = "Session length cannot be longer than ".concat(maxLen, ".");
    _this15.status = statusCodes['Bad Request'];
    return _this15;
  }

  return SessionLengthTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var AllowServerSideEncryptionMustBeBoolean = /*#__PURE__*/function (_Error16) {
  _inherits(AllowServerSideEncryptionMustBeBoolean, _Error16);

  var _super16 = _createSuper(AllowServerSideEncryptionMustBeBoolean);

  function AllowServerSideEncryptionMustBeBoolean() {
    var _this16;

    _classCallCheck(this, AllowServerSideEncryptionMustBeBoolean);

    for (var _len16 = arguments.length, params = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      params[_key16] = arguments[_key16];
    }

    _this16 = _super16.call.apply(_super16, [this].concat(params));
    _this16.name = 'AllowServerSideEncryptionMustBeBoolean';
    _this16.message = 'Allow server-side encryption value must be a boolean.';
    _this16.status = statusCodes['Bad Request'];
    return _this16;
  }

  return AllowServerSideEncryptionMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserAlreadySignedIn = /*#__PURE__*/function (_Error17) {
  _inherits(UserAlreadySignedIn, _Error17);

  var _super17 = _createSuper(UserAlreadySignedIn);

  function UserAlreadySignedIn(username) {
    var _this17;

    _classCallCheck(this, UserAlreadySignedIn);

    for (var _len17 = arguments.length, params = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
      params[_key17 - 1] = arguments[_key17];
    }

    _this17 = _super17.call.apply(_super17, [this].concat(params));
    _this17.name = 'UserAlreadySignedIn';
    _this17.message = 'Already signed in.';
    _this17.status = statusCodes['Bad Request'];
    _this17.username = username;
    return _this17;
  }

  return UserAlreadySignedIn;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserPendingDeletion = /*#__PURE__*/function (_Error18) {
  _inherits(UserPendingDeletion, _Error18);

  var _super18 = _createSuper(UserPendingDeletion);

  function UserPendingDeletion() {
    var _this18;

    _classCallCheck(this, UserPendingDeletion);

    for (var _len18 = arguments.length, params = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
      params[_key18] = arguments[_key18];
    }

    _this18 = _super18.call.apply(_super18, [this].concat(params));
    _this18.name = 'UserPendingDeletion';
    _this18.message = 'User is pending deletion.';
    _this18.status = statusCodes['Forbidden'];
    return _this18;
  }

  return UserPendingDeletion;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var AppIdNotValid = /*#__PURE__*/function (_Error19) {
  _inherits(AppIdNotValid, _Error19);

  var _super19 = _createSuper(AppIdNotValid);

  function AppIdNotValid() {
    var _this19;

    _classCallCheck(this, AppIdNotValid);

    for (var _len19 = arguments.length, params = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      params[_key19] = arguments[_key19];
    }

    _this19 = _super19.call.apply(_super19, [this].concat(params));
    _this19.name = 'AppIdNotValid';
    _this19.message = 'App ID not valid.';
    _this19.status = statusCodes['Unauthorized'];
    return _this19;
  }

  return AppIdNotValid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DomainNotWhitelisted = /*#__PURE__*/function (_Error20) {
  _inherits(DomainNotWhitelisted, _Error20);

  var _super20 = _createSuper(DomainNotWhitelisted);

  function DomainNotWhitelisted(domain) {
    var _this20;

    _classCallCheck(this, DomainNotWhitelisted);

    for (var _len20 = arguments.length, params = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
      params[_key20 - 1] = arguments[_key20];
    }

    _this20 = _super20.call.apply(_super20, [this, domain].concat(params));
    _this20.name = 'DomainNotWhitelisted';
    _this20.message = "Domain not whitelisted. Whitelist the domain ".concat(domain ? "'".concat(domain, "' ") : '', "in your admin panel.");
    _this20.status = statusCodes['Unauthorized'];
    return _this20;
  }

  return DomainNotWhitelisted;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserNotSignedIn = /*#__PURE__*/function (_Error21) {
  _inherits(UserNotSignedIn, _Error21);

  var _super21 = _createSuper(UserNotSignedIn);

  function UserNotSignedIn() {
    var _this21;

    _classCallCheck(this, UserNotSignedIn);

    for (var _len21 = arguments.length, params = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      params[_key21] = arguments[_key21];
    }

    _this21 = _super21.call.apply(_super21, [this].concat(params));
    _this21.name = 'UserNotSignedIn';
    _this21.message = 'Not signed in.';
    _this21.status = statusCodes['Bad Request'];
    return _this21;
  }

  return UserNotSignedIn;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserNotFound = /*#__PURE__*/function (_Error22) {
  _inherits(UserNotFound, _Error22);

  var _super22 = _createSuper(UserNotFound);

  function UserNotFound(username) {
    var _this22;

    _classCallCheck(this, UserNotFound);

    for (var _len22 = arguments.length, params = new Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
      params[_key22 - 1] = arguments[_key22];
    }

    _this22 = _super22.call.apply(_super22, [this, username].concat(params));
    if (username) _this22.username = username;
    _this22.name = 'UserNotFound';
    _this22.message = 'User not found.';
    _this22.status = statusCodes['Not Found'];
    return _this22;
  }

  return UserNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserEmailNotFound = /*#__PURE__*/function (_Error23) {
  _inherits(UserEmailNotFound, _Error23);

  var _super23 = _createSuper(UserEmailNotFound);

  function UserEmailNotFound() {
    var _this23;

    _classCallCheck(this, UserEmailNotFound);

    for (var _len23 = arguments.length, params = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      params[_key23] = arguments[_key23];
    }

    _this23 = _super23.call.apply(_super23, [this].concat(params));
    _this23.name = 'UserEmailNotFound';
    _this23.message = 'User does not have an email saved.';
    _this23.status = statusCodes['Not Found'];
    return _this23;
  }

  return UserEmailNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var UserMustChangePassword = /*#__PURE__*/function (_Error24) {
  _inherits(UserMustChangePassword, _Error24);

  var _super24 = _createSuper(UserMustChangePassword);

  function UserMustChangePassword() {
    var _this24;

    _classCallCheck(this, UserMustChangePassword);

    for (var _len24 = arguments.length, params = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      params[_key24] = arguments[_key24];
    }

    _this24 = _super24.call.apply(_super24, [this].concat(params));
    _this24.name = 'UserMustChangePassword';
    _this24.message = 'Must change password first.';
    _this24.status = statusCodes['Forbidden'];
    return _this24;
  }

  return UserMustChangePassword;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var EmailNotValid = /*#__PURE__*/function (_Error25) {
  _inherits(EmailNotValid, _Error25);

  var _super25 = _createSuper(EmailNotValid);

  function EmailNotValid() {
    var _this25;

    _classCallCheck(this, EmailNotValid);

    for (var _len25 = arguments.length, params = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
      params[_key25] = arguments[_key25];
    }

    _this25 = _super25.call.apply(_super25, [this].concat(params));
    _this25.name = 'EmailNotValid';
    _this25.message = 'Email not valid.';
    _this25.status = statusCodes['Bad Request'];
    return _this25;
  }

  return EmailNotValid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileMustBeObject = /*#__PURE__*/function (_Error26) {
  _inherits(ProfileMustBeObject, _Error26);

  var _super26 = _createSuper(ProfileMustBeObject);

  function ProfileMustBeObject() {
    var _this26;

    _classCallCheck(this, ProfileMustBeObject);

    for (var _len26 = arguments.length, params = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      params[_key26] = arguments[_key26];
    }

    _this26 = _super26.call.apply(_super26, [this].concat(params));
    _this26.name = 'ProfileMustBeObject';
    _this26.message = 'Profile must be a flat JSON object.';
    _this26.status = statusCodes['Bad Request'];
    return _this26;
  }

  return ProfileMustBeObject;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileCannotBeEmpty = /*#__PURE__*/function (_Error27) {
  _inherits(ProfileCannotBeEmpty, _Error27);

  var _super27 = _createSuper(ProfileCannotBeEmpty);

  function ProfileCannotBeEmpty() {
    var _this27;

    _classCallCheck(this, ProfileCannotBeEmpty);

    for (var _len27 = arguments.length, params = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
      params[_key27] = arguments[_key27];
    }

    _this27 = _super27.call.apply(_super27, [this].concat(params));
    _this27.name = 'ProfileCannotBeEmpty';
    _this27.message = 'Profile cannot be empty.';
    _this27.status = statusCodes['Bad Request'];
    return _this27;
  }

  return ProfileCannotBeEmpty;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileHasTooManyKeys = /*#__PURE__*/function (_Error28) {
  _inherits(ProfileHasTooManyKeys, _Error28);

  var _super28 = _createSuper(ProfileHasTooManyKeys);

  function ProfileHasTooManyKeys(maxKeys) {
    var _this28;

    _classCallCheck(this, ProfileHasTooManyKeys);

    for (var _len28 = arguments.length, params = new Array(_len28 > 1 ? _len28 - 1 : 0), _key28 = 1; _key28 < _len28; _key28++) {
      params[_key28 - 1] = arguments[_key28];
    }

    _this28 = _super28.call.apply(_super28, [this, maxKeys].concat(params));
    _this28.name = 'ProfileHasTooManyKeys';
    _this28.message = "Profile has too many keys. Must have a max of ".concat(maxKeys, " keys.");
    _this28.status = statusCodes['Bad Request'];
    return _this28;
  }

  return ProfileHasTooManyKeys;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileKeyTooLong = /*#__PURE__*/function (_Error29) {
  _inherits(ProfileKeyTooLong, _Error29);

  var _super29 = _createSuper(ProfileKeyTooLong);

  function ProfileKeyTooLong(maxLen, key) {
    var _this29;

    _classCallCheck(this, ProfileKeyTooLong);

    for (var _len29 = arguments.length, params = new Array(_len29 > 2 ? _len29 - 2 : 0), _key29 = 2; _key29 < _len29; _key29++) {
      params[_key29 - 2] = arguments[_key29];
    }

    _this29 = _super29.call.apply(_super29, [this, maxLen, key].concat(params));
    _this29.name = 'ProfileKeyTooLong';
    _this29.message = "Profile key too long. Must be a max of ".concat(maxLen, " characters.");
    _this29.status = statusCodes['Bad Request'];
    _this29.key = key;
    return _this29;
  }

  return ProfileKeyTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileValueMustBeString = /*#__PURE__*/function (_Error30) {
  _inherits(ProfileValueMustBeString, _Error30);

  var _super30 = _createSuper(ProfileValueMustBeString);

  function ProfileValueMustBeString(key, value) {
    var _this30;

    _classCallCheck(this, ProfileValueMustBeString);

    for (var _len30 = arguments.length, params = new Array(_len30 > 2 ? _len30 - 2 : 0), _key30 = 2; _key30 < _len30; _key30++) {
      params[_key30 - 2] = arguments[_key30];
    }

    _this30 = _super30.call.apply(_super30, [this, key, value].concat(params));
    _this30.name = 'ProfileValueMustBeString';
    _this30.message = 'Profile value must be a string.';
    _this30.status = statusCodes['Bad Request'];
    _this30.key = key;
    _this30.value = value;
    return _this30;
  }

  return ProfileValueMustBeString;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileValueCannotBeBlank = /*#__PURE__*/function (_Error31) {
  _inherits(ProfileValueCannotBeBlank, _Error31);

  var _super31 = _createSuper(ProfileValueCannotBeBlank);

  function ProfileValueCannotBeBlank(key) {
    var _this31;

    _classCallCheck(this, ProfileValueCannotBeBlank);

    for (var _len31 = arguments.length, params = new Array(_len31 > 1 ? _len31 - 1 : 0), _key31 = 1; _key31 < _len31; _key31++) {
      params[_key31 - 1] = arguments[_key31];
    }

    _this31 = _super31.call.apply(_super31, [this, key].concat(params));
    _this31.name = 'ProfileValueCannotBeBlank';
    _this31.message = 'Profile value cannot be blank.';
    _this31.status = statusCodes['Bad Request'];
    _this31.key = key;
    return _this31;
  }

  return ProfileValueCannotBeBlank;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ProfileValueTooLong = /*#__PURE__*/function (_Error32) {
  _inherits(ProfileValueTooLong, _Error32);

  var _super32 = _createSuper(ProfileValueTooLong);

  function ProfileValueTooLong(maxLen, key, value) {
    var _this32;

    _classCallCheck(this, ProfileValueTooLong);

    for (var _len32 = arguments.length, params = new Array(_len32 > 3 ? _len32 - 3 : 0), _key32 = 3; _key32 < _len32; _key32++) {
      params[_key32 - 3] = arguments[_key32];
    }

    _this32 = _super32.call.apply(_super32, [this, maxLen, key, value].concat(params));
    _this32.name = 'ProfileValueTooLong';
    _this32.message = "Profile value too long. Must be a max of ".concat(maxLen, " characters.");
    _this32.status = statusCodes['Bad Request'];
    _this32.key = key;
    _this32.value = value;
    return _this32;
  }

  return ProfileValueTooLong;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var RememberMeValueNotValid = /*#__PURE__*/function (_Error33) {
  _inherits(RememberMeValueNotValid, _Error33);

  var _super33 = _createSuper(RememberMeValueNotValid);

  function RememberMeValueNotValid(options) {
    var _this33;

    _classCallCheck(this, RememberMeValueNotValid);

    for (var _len33 = arguments.length, params = new Array(_len33 > 1 ? _len33 - 1 : 0), _key33 = 1; _key33 < _len33; _key33++) {
      params[_key33 - 1] = arguments[_key33];
    }

    _this33 = _super33.call.apply(_super33, [this, options].concat(params));
    _this33.name = 'RememberMeValueNotValid';
    _this33.message = "Remember me value must be one of ".concat(JSON.stringify(Object.keys(options)), ".");
    _this33.status = statusCodes['Bad Request'];
    return _this33;
  }

  return RememberMeValueNotValid;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ParamsMissing = /*#__PURE__*/function (_Error34) {
  _inherits(ParamsMissing, _Error34);

  var _super34 = _createSuper(ParamsMissing);

  function ParamsMissing() {
    var _this34;

    _classCallCheck(this, ParamsMissing);

    for (var _len34 = arguments.length, params = new Array(_len34), _key34 = 0; _key34 < _len34; _key34++) {
      params[_key34] = arguments[_key34];
    }

    _this34 = _super34.call.apply(_super34, [this].concat(params));
    _this34.name = 'ParamsMissing';
    _this34.message = 'Parameters expected are missing.';
    _this34.status = statusCodes['Bad Request'];
    return _this34;
  }

  return ParamsMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TrialExceededLimit = /*#__PURE__*/function (_Error35) {
  _inherits(TrialExceededLimit, _Error35);

  var _super35 = _createSuper(TrialExceededLimit);

  function TrialExceededLimit() {
    var _this35;

    _classCallCheck(this, TrialExceededLimit);

    for (var _len35 = arguments.length, params = new Array(_len35), _key35 = 0; _key35 < _len35; _key35++) {
      params[_key35] = arguments[_key35];
    }

    _this35 = _super35.call.apply(_super35, [this].concat(params));
    _this35.name = 'TrialExceededLimit';
    _this35.message = 'Trial exceeded limit of users.';
    _this35.status = statusCodes['Payment Required'];
    return _this35;
  }

  return TrialExceededLimit;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CurrentPasswordMissing = /*#__PURE__*/function (_Error36) {
  _inherits(CurrentPasswordMissing, _Error36);

  var _super36 = _createSuper(CurrentPasswordMissing);

  function CurrentPasswordMissing() {
    var _this36;

    _classCallCheck(this, CurrentPasswordMissing);

    for (var _len36 = arguments.length, params = new Array(_len36), _key36 = 0; _key36 < _len36; _key36++) {
      params[_key36] = arguments[_key36];
    }

    _this36 = _super36.call.apply(_super36, [this].concat(params));
    _this36.name = 'CurrentPasswordMissing';
    _this36.message = 'Current password missing.';
    _this36.status = statusCodes['Bad Request'];
    return _this36;
  }

  return CurrentPasswordMissing;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var CurrentPasswordIncorrect = /*#__PURE__*/function (_Error37) {
  _inherits(CurrentPasswordIncorrect, _Error37);

  var _super37 = _createSuper(CurrentPasswordIncorrect);

  function CurrentPasswordIncorrect() {
    var _this37;

    _classCallCheck(this, CurrentPasswordIncorrect);

    for (var _len37 = arguments.length, params = new Array(_len37), _key37 = 0; _key37 < _len37; _key37++) {
      params[_key37] = arguments[_key37];
    }

    _this37 = _super37.call.apply(_super37, [this].concat(params));
    _this37.name = 'CurrentPasswordIncorrect';
    _this37.message = 'Current password is incorrect.';
    _this37.status = statusCodes['Unauthorized'];
    return _this37;
  }

  return CurrentPasswordIncorrect;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var KeyNotFound = /*#__PURE__*/function (_Error38) {
  _inherits(KeyNotFound, _Error38);

  var _super38 = _createSuper(KeyNotFound);

  function KeyNotFound(message) {
    var _this38;

    _classCallCheck(this, KeyNotFound);

    for (var _len38 = arguments.length, params = new Array(_len38 > 1 ? _len38 - 1 : 0), _key38 = 1; _key38 < _len38; _key38++) {
      params[_key38 - 1] = arguments[_key38];
    }

    _this38 = _super38.call.apply(_super38, [this, message].concat(params));
    _this38.name = 'KeyNotFound';
    _this38.message = message;
    _this38.status = statusCodes['Not Found'];
    return _this38;
  }

  return KeyNotFound;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var DeleteEndToEndEncryptedDataMustBeBoolean = /*#__PURE__*/function (_Error39) {
  _inherits(DeleteEndToEndEncryptedDataMustBeBoolean, _Error39);

  var _super39 = _createSuper(DeleteEndToEndEncryptedDataMustBeBoolean);

  function DeleteEndToEndEncryptedDataMustBeBoolean() {
    var _this39;

    _classCallCheck(this, DeleteEndToEndEncryptedDataMustBeBoolean);

    for (var _len39 = arguments.length, params = new Array(_len39), _key39 = 0; _key39 < _len39; _key39++) {
      params[_key39] = arguments[_key39];
    }

    _this39 = _super39.call.apply(_super39, [this].concat(params));
    _this39.name = 'DeleteEndToEndEncryptedDataMustBeBoolean';
    _this39.message = 'Delete end-to-end encrypted data value must be a boolean.';
    _this39.status = statusCodes['Bad Request'];
    return _this39;
  }

  return DeleteEndToEndEncryptedDataMustBeBoolean;
}( /*#__PURE__*/_wrapNativeSuper(Error));

export default {
  UsernameAlreadyExists: UsernameAlreadyExists,
  UsernameMissing: UsernameMissing,
  UsernameCannotBeBlank: UsernameCannotBeBlank,
  UsernameTooLong: UsernameTooLong,
  UsernameMustBeString: UsernameMustBeString,
  PasswordMissing: PasswordMissing,
  PasswordCannotBeBlank: PasswordCannotBeBlank,
  PasswordTooShort: PasswordTooShort,
  PasswordTooLong: PasswordTooLong,
  PasswordMustBeString: PasswordMustBeString,
  PasswordAttemptLimitExceeded: PasswordAttemptLimitExceeded,
  UsernameOrPasswordMismatch: UsernameOrPasswordMismatch,
  SessionLengthMustBeNumber: SessionLengthMustBeNumber,
  SessionLengthTooShort: SessionLengthTooShort,
  SessionLengthTooLong: SessionLengthTooLong,
  AllowServerSideEncryptionMustBeBoolean: AllowServerSideEncryptionMustBeBoolean,
  UserAlreadySignedIn: UserAlreadySignedIn,
  UserPendingDeletion: UserPendingDeletion,
  AppIdNotValid: AppIdNotValid,
  DomainNotWhitelisted: DomainNotWhitelisted,
  UserNotSignedIn: UserNotSignedIn,
  UserNotFound: UserNotFound,
  UserEmailNotFound: UserEmailNotFound,
  UserMustChangePassword: UserMustChangePassword,
  EmailNotValid: EmailNotValid,
  ProfileMustBeObject: ProfileMustBeObject,
  ProfileCannotBeEmpty: ProfileCannotBeEmpty,
  ProfileHasTooManyKeys: ProfileHasTooManyKeys,
  ProfileKeyTooLong: ProfileKeyTooLong,
  ProfileValueMustBeString: ProfileValueMustBeString,
  ProfileValueCannotBeBlank: ProfileValueCannotBeBlank,
  ProfileValueTooLong: ProfileValueTooLong,
  RememberMeValueNotValid: RememberMeValueNotValid,
  ParamsMissing: ParamsMissing,
  TrialExceededLimit: TrialExceededLimit,
  CurrentPasswordMissing: CurrentPasswordMissing,
  CurrentPasswordIncorrect: CurrentPasswordIncorrect,
  KeyNotFound: KeyNotFound,
  DeleteEndToEndEncryptedDataMustBeBoolean: DeleteEndToEndEncryptedDataMustBeBoolean
};